import { Group, Input, TextInput, type TextInputProps } from "@mantine/core";
import { DEFAULT_ISD, parsePhoneLocal } from "../lib/phone";
import { axioTokens } from "../theme";

type PhoneInputProps = Omit<TextInputProps, "value" | "onChange" | "type"> & {
  value?: string;
  onChange?: (value: string) => void;
};

export function PhoneInput({
  value = "",
  onChange,
  label = "Phone",
  error,
  required,
  disabled,
  size,
  description,
  ...rest
}: PhoneInputProps) {
  const local = parsePhoneLocal(value);

  function handleLocalChange(nextRaw: string) {
    const digits = nextRaw.replace(/\D/g, "").slice(0, 10);
    onChange?.(digits);
  }

  return (
    <Input.Wrapper label={label} required={required} error={error} description={description} size={size}>
      <Group gap="xs" wrap="nowrap" align="flex-start" mt={label ? axioTokens.spacing.xs : axioTokens.unit[0]}>
        <TextInput
          value={DEFAULT_ISD}
          disabled
          aria-label="Country code"
          size={size}
          styles={{ input: { textAlign: "center", fontWeight: "var(--axio-font-weight-medium)" } }}
          style={{ flex: `0 0 ${axioTokens.dimension.phonePrefixWidth}` }}
        />
        <TextInput
          {...rest}
          value={local}
          onChange={(e) => handleLocalChange(e.currentTarget.value)}
          placeholder="9876543210"
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          disabled={disabled}
          size={size}
          style={{ flex: "var(--axio-number-one)" }}
          aria-label={typeof label === "string" ? label : "Mobile number"}
        />
      </Group>
    </Input.Wrapper>
  );
}
